export default "\n\n    <div class=\"layout-topbar\">    \n        <app-site-logo></app-site-logo>\n    </div>\n\n\n";